// File: src/layouts/NoContainer.js
// requirement in layoutConfig (App.js)

import { useLocation } from "react-router-dom";

export default function NoContainer({ children }) {
  const location = useLocation();
  const isPublicFullBleedPath =
    location.pathname === "/" ||
    location.pathname === "/leitbild" ||
    location.pathname === "/roadmap" ||
    location.pathname === "/public/roadmap" ||
    location.pathname === "/stb/job-marketplace" ||
    location.pathname === "/applicant/frontdoor" ||
    location.pathname === "/login" ||
    location.pathname === "/register" ||
    location.pathname === "/impressum" ||
    location.pathname === "/agb" ||
    location.pathname === "/datenschutz";
  const isPublicFamilySubroute = location.pathname.startsWith("/menue/");
  const isApplicantWorkspace = location.pathname.startsWith("/dashboard/applicant");
  const isSecurityWorkspace = location.pathname.startsWith("/dashboard/security");

  if (isPublicFullBleedPath || isPublicFamilySubroute || isSecurityWorkspace || isApplicantWorkspace) {
    return <div className="min-h-screen p-0 m-0">{children}</div>;
  }

  return <div className="min-h-screen px-5 pt-20">{children}</div>;
}
